import ArrowLeft from '@ui-components-3/icons/lib/duotone/ArrowLeft'
import ArrowRight from '@ui-components-3/icons/lib/duotone/ArrowRight'

type GraphPaginationProps = {
  pagination: any
  onPageChange: (page: number) => void
  currentPageNumber: number
}

const GraphPagination = ({ onPageChange, pagination, currentPageNumber }: GraphPaginationProps) => {
  const { lastPageNumber, incremnetDisabled, decrementDisabled, page } = pagination

  const onNext = () => {
    onPageChange(page + 1)
  }

  const onPrevious = () => {
    onPageChange(page - 1)
  }

  return (
    <div className="flex justify-center gap-xs items-center text-neutral-600 w-full pt-1">
      <button type="button" className="btn-tiny btn-neutral-borderless" onClick={onNext} disabled={incremnetDisabled}>
        <ArrowLeft aria-label="Previous page" />
      </button>
      {currentPageNumber} of {lastPageNumber}
      <button
        type="button"
        className="btn-tiny btn-neutral-borderless"
        onClick={onPrevious}
        disabled={decrementDisabled}
      >
        <ArrowRight aria-label="Next page" />
      </button>
    </div>
  )
}

export default GraphPagination
